// Eager module — imported by the always-mounted TourManager. Keep it dependency-free:
// steps.ts and the engine live in the lazy chunk (spec §3.1), so nothing here may
// import them or anything heavy. (@/lib/classroomRoutes is itself dependency-free.)
import { isClassroomPath } from "@/lib/classroomRoutes";

export const TOUR_VERSION = { student: 1, tutor: 1 } as const;
export type TourKey = keyof typeof TOUR_VERSION;

// A tour must never run inside a call (worst possible moment). What counts as a call is the one rule the
// cookie banner follows too, so the two cannot drift (#1031): isClassroomPath.
const DASHBOARD = /^\/(student|tutor)(\/|$)/;

// Where the welcome card may appear by itself. /messages is excluded (a deep link
// to a conversation must not be interrupted) but a RUNNING tour may continue there.
export function canAutoStart(pathname: string): boolean {
  if (isClassroomPath(pathname)) return false;
  if (pathname.startsWith("/onboarding")) return false;
  return DASHBOARD.test(pathname);
}

export function canContinue(pathname: string): boolean {
  if (isClassroomPath(pathname)) return false;
  return DASHBOARD.test(pathname) || pathname === "/messages";
}

// sessionStorage: Esc = "not now" for THIS session. localStorage: resume point.
export const TOUR_SESSION_SUPPRESS_KEY = "jynio.tour.dismissedThisSession";
export const TOUR_RESUME_STEP_KEY = "jynio.tour.resumeStep";
